// extracted by mini-css-extract-plugin
export default {"echCollection":"Collection_echCollection__MNrOG"};